import { z } from "zod";


export const userPreferencesSchema = z.object({
    orderUpdates: z.boolean(),
    promotions: z.boolean(),
    restock: z.boolean(),
  })